const { MERGE_PAGE_DATA, SET_PAGE_DATA, SHOW_SPA_PAGE_LOAD_PROGRESS } = require('constants/actionTypes/page');
const { SET_NTH_CATEGORY } = require('constants/actionTypes/nthCategory');
const { SET_NTH_BRAND } = require('constants/actionTypes/nthBrand');
const { SET_SEARCH } = require('constants/actionTypes/search');
const { SET_PRODUCT } = require('constants/actionTypes/product');
const { SET_CONTENT_STORE } = require('../constants/actionTypes/contentStore');
const { SET_BUY_PAGE } = require('constants/actionTypes/buy');
const { SET_HOME_PAGE } = require('constants/actionTypes/home');
const { SET_CONTENT } = require('constants/actionTypes/content');
const { SET_ENHANCED_CONTENT } = require('constants/actionTypes/enhancedContent');
const { SET_SMART_SKIN_SCAN_CONTENT } = require('constants/actionTypes/smartSkinScan');
const { SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT } = require('constants/actionTypes/photoCaptureSmartSkinScan');
const { SET_GALLERY_CONTENT } = require('constants/actionTypes/gallery');
const { SET_GALLERY_PROFILE_CONTENT } = require('constants/actionTypes/myProfile');
const { SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT } = require('constants/actionTypes/userPublicGallery');
const basketActionTypes = require('constants/actionTypes/basket');
const {
    ACTION_TYPES: { SET_RWD_BASKET }
} = require('reducers/rwdBasket');
const CookieUtils = require('utils/Cookies');
const home = require('./page/home');
const nthCategory = require('./page/nthCategory');
const nthBrand = require('./page/nthBrand');
const search = require('./page/search');
const buy = require('./page/buy');
const content = require('./page/content');
const enhancedContent = require('./page/enhancedContent');
const photoCaptureSmartSkinScan = require('./page/photoCaptureSmartSkinScan');
const smartSkinScan = require('./page/smartSkinScan');
const gallery = require('./page/gallery');
const myProfile = require('./page/myProfile');
const autoReplenishment = require('reducers/page/autoReplenishment');
const sameDayUnlimited = require('reducers/sameDayUnlimited');
const contentStoreData = require('./page/contentStore');
const PageTemplateType = require('constants/PageTemplateType');
const product = require('./product');

const {
    KEYS: { DEVICE_TYPE }
} = CookieUtils;
const initialState = {
    showLoadSpaPageProgress: null,
    nthCategory: {},
    nthBrand: {},
    product: {},
    templateInformation: {},
    search: {},
    contentStoreData: {},
    home: {},
    buy: {},
    autoReplenishment: autoReplenishment.initialState,
    sameDayUnlimited: sameDayUnlimited.initialState,
    content: {},
    enhancedContent: {},
    smartSkinScan: {},
    photoCaptureSmartSkinScan: {},
    basket: {},
    rwdBasket: {}
};

// eslint-disable-next-line complexity
const page = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PAGE_DATA: {
            return payload || initialState;
        }
        case MERGE_PAGE_DATA: {
            return {
                ...state,
                ...payload
            };
        }
        case SHOW_SPA_PAGE_LOAD_PROGRESS: {
            return {
                ...state,
                showLoadSpaPageProgress: payload
            };
        }
        default: {
            let newState = state;
            Object.keys(pageReducers).forEach(reducerName => {
                const originalSubState = state[reducerName];
                const reducer = pageReducers[reducerName];
                const newSubState = reducer(originalSubState, action);

                if (originalSubState !== newSubState) {
                    newState = {
                        ...newState,
                        [reducerName]: newSubState
                    };
                }
            });

            if (type === SET_PRODUCT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.ProductPage
                    }
                };
            } else if (type === SET_NTH_CATEGORY) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.NthCategory
                    }
                };
            } else if (type === SET_NTH_BRAND) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.BrandNthCategory
                    }
                };
            } else if (type === basketActionTypes.SET_BASKET) {
                const deviceType = CookieUtils.read(DEVICE_TYPE) === 'desktop' ? 'FS' : 'MW';
                const channel = deviceType || 'FS';
                newState = {
                    ...newState,
                    templateInformation: {
                        channel,
                        template: PageTemplateType.Basket
                    }
                };
            } else if (type === SET_RWD_BASKET) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.RwdBasket
                    }
                };
            } else if (type === SET_SEARCH) {
                Sephora.pagePath = PageTemplateType.Search;
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.Search
                    }
                };
            } else if (type === SET_CONTENT_STORE) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.RwdContentStore
                    }
                };
            } else if (type === SET_BUY_PAGE) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.BuyPage
                    }
                };
            } else if (type === SET_HOME_PAGE) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.Homepage
                    }
                };
            } else if (type === SET_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.Content
                    }
                };
            } else if (type === SET_ENHANCED_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.EnhancedContent
                    }
                };
            } else if (type === SET_SMART_SKIN_SCAN_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.SmartSkinScan
                    }
                };
            } else if (type === SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.photoCaptureSmartSkinScan
                    }
                };
            } else if (type === SET_GALLERY_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.GalleryPage
                    }
                };
            } else if (type === SET_GALLERY_PROFILE_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.MyGalleryPage
                    }
                };
            } else if (type === SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT) {
                newState = {
                    ...newState,
                    templateInformation: {
                        channel: 'RWD',
                        template: PageTemplateType.CommunityUserPublicGallery
                    }
                };
            }

            return newState;
        }
    }
};

const withMerge = (reducerName, reducer) => (state, action) => {
    switch (action.type) {
        case `page.${reducerName}_MERGE`: {
            // eslint-disable-next-line object-curly-newline
            const { key, value } = action.payload;

            return {
                ...state,
                [key]: value
            };
        }
        default: {
            return reducer(state, action);
        }
    }
};
page.withMerge = withMerge;

let pageReducers;
const wrapReducers = () => {
    pageReducers = {
        product,
        nthCategory,
        nthBrand,
        search,
        contentStoreData,
        buy,
        home,
        autoReplenishment: autoReplenishment.reducer,
        sameDayUnlimited: sameDayUnlimited.reducer,
        content,
        enhancedContent,
        smartSkinScan,
        photoCaptureSmartSkinScan,
        gallery,
        myProfile
    };
    Object.keys(pageReducers).forEach(reducerName => {
        pageReducers[reducerName] = page.withMerge(reducerName, pageReducers[reducerName]);
    });
    page.pageReducers = pageReducers;
};
wrapReducers();
page.wrapReducers = wrapReducers;

module.exports = page;
